import { createGlobalStyle } from "styled-components";
import GravityRegular from "../../fonts/Gravity-Regular.otf";
const FontStyles = createGlobalStyle`
    @font-face {
        font-family: Gravity;
        src: url(${GravityRegular}) format("opentype");
    }
`;
export default FontStyles;
